import CustomerForm from '../components/Customer/CustomerForm';
import { Route,NavLink } from 'react-router-dom'
const OnboardForms =props=>{
   //if(sessionStorage.getItem('user_id')>0){
    return (
        <div class="onboard_form">
          <h2>Onboard Forms</h2>
         <ul>
                  <li>
                      <NavLink to="/onboard/customer">Customer</NavLink>
                  </li>
                  <li>
                      <NavLink to="/onboard/seller">Seller</NavLink>
                  </li>
                 
              </ul>
          {/* <article>
      <h1>Our services are currently undergoing maintenance.</h1>
      <div>
          <p>If you require further assistance, please <a href="mailto:support@autozilla.co">contact us</a> to +91 6281159079 for support.</p>
          <p>Thank you for your understanding.</p>
          <p>&mdash; Autozilla Team</p>
      </div>
  </article> */}
  
        </div>
      );
//    }else{
//     window.location.href='https://app.autozilla.co/onboard/login';
//    }
    
}

export default OnboardForms;